import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { AppGeneralContext } from '../../../shared/GeneralContext/GeneralContext';
import './Billings.css'
import BillingInfoTop from '../../molecules/BillingInfoTop/BillingInfoTop';
import iconPink from '../../../img/icons/VectorPink.png'
import useMediaQuery from '../../../hook/useMediaQuery';
import { Loader, Logo } from '../../atoms';
import { MediaDesktop, MediaMobile, MediaSmallMobile, MediaTablet } from '../../../api/const/MediaQuery';
import useMediaQueryMinMax from '../../../hook/useMediaQueryMinMax';
import clsx from 'clsx';
import { BillingsAccordion } from '../../molecules/BillingsAccordion';
import billingsData from './../../../jsonMock/billingsDataMock.json';
import { getBillingInfo, postBillingList } from 'api/Api';
import { Billing, BillingListData } from 'components/types/types';
import { Pager, PaginatedRequest } from 'components/types/Api';
import useIntersection from 'hook/useIntersection';

export const Billings = () => {
    const { setLoadingModal, setErrorModal, setClosedModal } = useContext(AppGeneralContext)
    const [billingInfo, setBillingInfo] = useState<Billing>()
    const [billingListData, setBillingListData] = useState<BillingListData[]>()
    const [reqBillingList, setReqBillingList] = useState<PaginatedRequest>({ pageNum: 0, pageSize: 6, orderBy: "", orderDirection: "desc" })
    const [billingPager, setReqBillingPager] = useState<Pager>({ totalItems: 0, pageNum: 0, pageSize: 0, totalPages: 0, startPage: 0, endPage: 0 })
    const [loadingList, setLoadingList] = useState(true)
    const xsMobile = useMediaQuery(MediaSmallMobile)
    const tablet = useMediaQuery(MediaTablet)
    const desktop = useMediaQuery(MediaDesktop)
    const mobile = useMediaQuery(MediaMobile)

    const refBottomTable = useRef<HTMLDivElement | any>();
    const inViewport = useIntersection(refBottomTable, '10px');

    const title = useMemo(() => {
        if ((tablet || mobile) && !xsMobile) {
            return <h4 className='mb-0 '>Current month detail</h4>
        } else if ((tablet || mobile) && xsMobile) {
            return <h4 className='mb-0'>Current month detail</h4>
        } else {
            return <h3 className='mb-0'>Current <br />month <br />detail</h3>
        }
    }, [xsMobile, mobile, tablet])

    useEffect(() => {
        if (inViewport?.isVisible && !loadingList) {
            if (billingPager?.pageNum + 1 < billingPager.totalPages) {
                setReqBillingList({ ...reqBillingList, pageNum: billingPager?.pageNum + 1 })
            }
        }
    }, [inViewport, billingPager, reqBillingList, loadingList])


    useEffect(() => {
        setLoadingModal()
        getBillingInfo().then((res) => {

            if (!res.isSuccess || !res.response) {
                setErrorModal(res.error)
                return
            }

            const response = res.response
            setBillingInfo(res.response)
            setClosedModal()
        })
    }, [])


    const postBillList = useCallback(
        () => {
            setLoadingList(true)
            postBillingList(reqBillingList).then((res) => {
                setLoadingList(false)

                if (!res.isSuccess || !res.response) {
                    setErrorModal(res.error)
                    return
                }

                const currentBillingList = billingListData ?? []
                const billingList = currentBillingList.concat(res.response.data)

                setBillingListData(billingList)
                setReqBillingPager(res.response.pager)
                setClosedModal()
            })
        },
        [reqBillingList, billingListData],
    )


    useEffect(() => {
        postBillList()
    }, [reqBillingList])


    return (
        <>

            <div className={clsx("row m-0 p-0  mt-5 me-4",{"ms-4":tablet})}>
                <div className={clsx("w-100 m-0 p-0  ",
                    { "mb-5": !tablet })}>
                    <div className={clsx("d-flex  p-0 m-0 ",
                        { "flex-row justify-content-between": !tablet },
                        { "flex-column": tablet }
                    )}>
                        <div className={clsx("d-flex align-items-start me-3 ",
                            { "w-15 ": !tablet },
                            { "mb-1 justify-content-end w-100": tablet })}>
                            {title}
                        </div>
                        <div className="w-100   d-flex flex-row justify-content-end">
                            <BillingInfoTop billing={billingInfo} />
                        </div>
                    </div>
                </div>
                <div className=" mt-5 mb-5  ">
                    <div className='d-flex flex-row align-items-center'>
                        <Logo colorLogo='var(--primary)' className='logo-h3' />
                        <h3 className='m-0 fw-700'>Billings</h3>
                    </div>
                </div>
                <div className="m-0 p-0 mb-5 ">
                    <BillingsAccordion data={billingListData} />
                    {loadingList && <Loader />}
                    <div ref={refBottomTable}></div>

                </div>
                {tablet &&
                    <div className="m-0 p-0 mb-5 footer-margin " />
                }
            </div>

        </>
    );
}

